import { render, staticRenderFns } from "./terms-modal.vue?vue&type=template&id=3bd66be0"
import script from "./terms-modal.vue?vue&type=script&lang=js"
export * from "./terms-modal.vue?vue&type=script&lang=js"
import style0 from "./terms-modal.vue?vue&type=style&index=0&id=3bd66be0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports